import React from "react";
import myImage from '../Ssl.jpeg';
import { Container, Grid, Typography } from "@material-ui/core";

function Footer() {
  return (
    <footer>
      {/* <Container>
        <Grid container justifyContent="center">
          <Grid item>
            <Typography variant="body1" color="textSecondary" align="center">
              Copyright &copy; nooor.xyz
              <img src={myImage} alt="" />
            </Typography>
          </Grid>
        </Grid>
      </Container> */}
      <div class="container my-4">
  <div class="row">
    <div class="col-md-6">
      <img src={myImage} alt="Sample" class="img-fluid" />
    </div>

    <div class="col-md-6 d-flex align-items-center">
      <p>
            Copyright &copy; nooor.xyz
      </p>
    </div>
  </div>
</div>
    </footer>
  );
}

export default Footer;